export {
  isInCloudStorage,
  getPalette,
  getServiceName,
  getODSPFileNavigationParams,
  getGoogleFileNavigationParams,
  getWopiFileNavigationParams,
  removeFileNameFromObjectUrl,
  getFileTypeClass,
  getDomainFromSiteUrl,
  getSiteUrl,
  getServerRelativeUrlFromSiteUrl,
  scrubUnknownFileExtensions,
  getFileExtension,
  dropObjectUrlQueryParams,
  getLCID,
  convertStringToProviderType,
  convertSerializedStringToProviderType,
  isRootChannelFolder,
  postMessage,
  extractCorrelationId,
  getOriginFromUrl,
  getScenarioName
} from "./src/file-utils";
